import { dispatchAlertToaster } from 'adapter/in/common/context/Alert';
import i18n from 'asset/translation';
import React, { createContext, useContext, useRef, ReactNode } from 'react';

type ExportChartType = {
    type: 'application/pdf' | 'image/jpeg' | 'image/png' | 'image/svg+xml';
};

export type ChartRefObject = {
    chart: { exportChart: (exportParams: ExportChartType) => void; getSVG: () => string };
} | null;

type ChartExportContextProps = {
    exportAndDownloadChartAsPNG: () => void;
    setChartRef?: (ref: React.MutableRefObject<ChartRefObject>) => void;
};

const ChartExportContext = createContext<ChartExportContextProps>({
    exportAndDownloadChartAsPNG: () => {
        throw new Error('useChartExport exportAndDownloadChartAsPNG must be used within a ChartExportProvider');
    },
});

export const useChartExport = (): ChartExportContextProps => useContext(ChartExportContext);

interface ChartExportProviderProps {
    children: ReactNode;
}

export const ChartExportProvider: React.FC<ChartExportProviderProps> = ({ children }) => {
    let chartRef = useRef<ChartRefObject>(null);
    const { setErrorAlert } = dispatchAlertToaster();

    const setChartRef = (ref: React.MutableRefObject<ChartRefObject>) => {
        chartRef = ref;
    };

    const exportAndDownloadChartAsPNG = () => {
        if (chartRef.current) {
            chartRef.current.chart.exportChart({
                type: 'image/png',
            });
        } else {
            setErrorAlert(i18n.t('advancedAnalytics.exportAndDownloadChartAsPNGNotAvailable'));
        }
    };

    return <ChartExportContext.Provider value={{ setChartRef, exportAndDownloadChartAsPNG }}>{children}</ChartExportContext.Provider>;
};
